import { render, staticRenderFns } from "./TicketsPage.vue?vue&type=template&id=5245a87b&"
import script from "./TicketsPage.vue?vue&type=script&lang=js&"
export * from "./TicketsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5245a87b')) {
      api.createRecord('5245a87b', component.options)
    } else {
      api.reload('5245a87b', component.options)
    }
    module.hot.accept("./TicketsPage.vue?vue&type=template&id=5245a87b&", function () {
      api.rerender('5245a87b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/coLiving/TicketsPage.vue"
export default component.exports